var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money 2",
    clipPath: "url(#clip0_6801_2949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M6.86423 5.85976H33.1359C32.2708 4.5989 31.6945 3.12539 31.5029 1.535H8.4972C8.30556 3.12539 7.72931 4.5989 6.86423 5.85976Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M36.229 5.85976H40V2.99859C40 2.19156 39.3435 1.535 38.5364 1.535H33.8691C34.1417 3.24023 34.9992 4.75281 36.229 5.85976Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M3.77102 5.85976C5.00078 4.75281 5.85828 3.24023 6.13094 1.53492H1.46359C0.656562 1.53492 0 2.19156 0 2.99859V5.85976H3.77102Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.6,
    d: "M4.03125 12.2825C5.12148 11.2021 5.87789 9.78578 6.13094 8.20351H0V12.2825H4.03125Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M8.49719 8.20351C8.31789 9.69156 7.80234 11.0776 7.02805 12.2825H32.972C32.1977 11.0776 31.6821 9.69156 31.5029 8.20351H8.49719Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.6,
    d: "M40 8.20351H33.8691C34.122 9.78578 34.8785 11.2021 35.9688 12.2825H40V8.20351Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 32.3341V37.0014C0 37.8084 0.656562 38.465 1.46359 38.465H6.13094C5.62867 35.3237 3.14141 32.8363 0 32.3341Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.13094 14.6263H0V20.7572C3.14141 20.2549 5.62867 17.7677 6.13094 14.6263Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.5028 14.6263H8.49719C7.96281 19.0619 4.43563 22.5891 0 23.1234V29.9678C4.43563 30.5022 7.96281 34.0293 8.49719 38.465H31.5029C32.0373 34.0294 35.5644 30.5022 40.0001 29.9678V23.1234C35.5644 22.5891 32.0372 19.0619 31.5028 14.6263ZM21.3366 25.3881C24.5745 26.4903 24.2885 30.9814 21.1138 32.0708V32.4237C21.0519 33.9786 18.8314 33.9774 18.7701 32.4237V32.196C18.1465 32.103 17.6011 31.8873 16.8837 31.418C16.342 31.0638 16.1902 30.3374 16.5445 29.7958C16.8988 29.254 17.625 29.1022 18.1666 29.4566C18.8226 29.8855 19.0505 29.9226 19.9341 29.9159C20.7305 29.9106 21.1927 29.3171 21.285 28.7679C21.3391 28.4464 21.3161 27.8668 20.5554 27.5979C18.4655 26.851 16.2248 26.0119 16.6793 23.3903C16.8981 22.2289 17.6961 21.2998 18.7701 20.9435V20.6677C18.832 19.1128 21.0525 19.114 21.1138 20.6677V20.8719C21.7717 21.0501 22.2321 21.3526 22.4252 21.4969C22.9437 21.8844 23.0498 22.6187 22.6623 23.1371C22.2748 23.6555 21.5406 23.7617 21.022 23.3741C20.8316 23.2318 20.3044 22.9259 19.5258 23.1605C19.1144 23.2845 19.006 23.6999 18.9825 23.8244C18.9351 24.0762 18.9961 24.2799 19.0776 24.3438C19.5802 24.738 20.5016 25.0929 21.3366 25.3881Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40 32.3341C36.8586 32.8363 34.3713 35.3236 33.8691 38.465H38.5364C39.3435 38.465 40 37.8084 40 37.0014V32.3341Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40 14.6263H33.8691C34.3713 17.7677 36.8586 20.2549 40 20.7572V14.6263Z",
    fill: "#7FD7A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6801_2949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.20b4b86877da64bb6a62574a83252f5b.svg";
export { ForwardRef as ReactComponent };